import { writable, get } from 'svelte/store';


const _default = {
	state: null,
	chatCallback: null,
	calendarCallback: null,
};


const { subscribe, set, update } = writable(Object.assign({}, _default));


export const navi = {
	subscribe,

	/* pull */
	pull: prop =>
		prop ? get(navi)[prop] : get(navi),

	/* push */
	push: value =>
		update(self => Object.assign(self, value)),
};
